<template>
  <div>
    <form :id="`form-create-${model}`" :data-testid="`form-create-${model}`" role="form" class="elr-form elr-container" @submit.prevent.stop="create">
      <ErrorList v-if="hasErrors" :fields="fieldNames" :errors="errors" />
      <slot />
      <div class="form-input-holder">
        <ButtonSubmit>{{buttonText}}</ButtonSubmit>
      </div>
    </form>
  </div>
</template>

<script>
import { capitalize, deslugify } from '../../utils/helpers';
import ErrorList from '../ErrorList/ErrorList';
import ButtonSubmit from '../ButtonSubmit/ButtonSubmit';

export default {
  name: 'FormCreate',
  props: {
    errors: {
      type: Object
    },
    fields: {
      type: Array,
      required: true
    },
    model: {
      type: String,
      required: true
    }
  },
  components: {
    ButtonSubmit,
    ErrorList
  },
  computed: {
    buttonText() {
      return `Create ${capitalize(deslugify(this.model))}`;
    },
    fieldNames() {
      return this.fields;
    },
    hasErrors() {
      if (this.errors) {
        return !!Object.keys(this.errors).length;
      }

      return false;
    }
  },
  methods: {
    create() {
      this.$emit('submitted')
    }
  }
};
</script>

<style lang="scss" scoped>

@import '../../assets/sass/config';

.error-message {
  color: $red;
}
</style>

